import React from 'react';
import CommitteeMemberFormContainer from '../../../../Containers/AdminContainer/CommitteeMember/CommitteeMemberForm';
const CommitteeMemberFormScreen = () => {
  return <CommitteeMemberFormContainer />;
};

export default CommitteeMemberFormScreen;
